<template>
  <b-container>
    <h1>{{ $t("tracking.disapprovedReason.create") }}</h1>
    <success-fade-alert ref="alert" :msg="alert.success" />
    <fade-alert-danger ref="fadeAlertDanger" :msg="alert.error" />
    <b-row class="mb-3 ml-0">
      <router-link :to="getUrlBackToList">
        <b-button size="sm">{{ $t("geral.backtolist") }}</b-button>
      </router-link>
    </b-row>
    <b-row>
      <b-col sm="12" md="6" lg="6">
        <disapproved-reason-crud-data
          :model="model"
          :modelstate="modelstate"
          :readonly="false"
          class="mb-4"
        >
        </disapproved-reason-crud-data>
      </b-col>
    </b-row>
    <b-row>
      <b-col>
        <b-button type="submit" :disabled="submitted" @click="save">
          {{ $t("geral.save") }}
        </b-button>
      </b-col>
    </b-row>
  </b-container>
</template>
<script>
export default {
  name: "DisapprovedReasonCreate",
  directives: {},
  components: {
    FadeAlertDanger: () => import("@/components/FadeAlertDanger.vue"),
    SuccessFadeAlert: () => import("@/components/SuccessFadeAlert.vue"),
    DisapprovedReasonCrudData: () =>
      import(
        "@/components_rms/trackingShippingCompany/disapprovedReason/DisapprovedReasonCrudData.vue"
      ),
  },
  data() {
    return {
      alert: {
        error: "",
        success: "Motivo de reprovação criado com sucesso",
      },
      submitted: false,
      modelstate: {},
      model: {
        sequenceNumber: "",
        displayName: "",
      },
    };
  },
  created() {
    this.newModel();
  },
  mounted() {},
  computed: {
    getUrlBackToList() {
      return `/trackingShippingCompany/disapprovedReason/list`;
    },
    getNewModel() {
      return `/v1/disapprovedReason/newModel`;
    },
    getAllById() {
      return `/v1/disapprovedReason/getAll`;
    },
  },
  methods: {
    async newModel() {
      console.log(this.getNewModel);
      this.$api.get(this.getNewModel).then((response) => {
        // console.log("entrou");
        // console.log(response.data);
        let model = response.data;
        this.model.sequenceNumber = model;
        this.model.displayName = " ";
        console.log(model.sequenceNumber);
      });
    },
    async getAllById() {
      console.log(this.getAllById);
      this.$api
        .get(this.getAllById)
        .then((response) => {
          // console.log("entrou");
          // console.log(response.data);
          let model = response.data;
          this.model.occurrenceTypeNext = model;
          console.log(model.occurrenceTypeNext);
        })
        .catch((error) => {
          if (error.response.status == 401) {
            console.log(response.data);
            this.$store.dispatch("logout").then(() => {
              this.$router.push("/login");
            });
          } else {
            if (error.response) {
              if (error.response.status == 400) {
                console.log(response.data);
                this.modelstate = error.response.data.errors;
              }
            }
            this.alert.error = error.message;
            this.$refs.danger.show();
          }
        });
    },
    save() {
      this.submitted = true;

      this.$api
        .post("/v1/disapprovedReason/create", this.model)
        .then((response) => {
          this.newModel();
          this.newModel();
          this.$refs.alert.show();
          this.modelstate = {};
          this.submitted = false;
        })
        .catch((error) => {
          this.submitted = false;
          this.modelstate = {};
          if (error.response) {
            console.log(error.response);
            if (error.response.status == 400) {
              console.log(error.response);
              console.log(error.response.data);
              console.log(error.response.data.errors);
              this.modelstate = error.response.data.errors;
              this.alert.error = "Verifique os dados informados";
            } else {
              if (error.response.data) {
                console.log(error.response.data);
                this.alert.error = `${error.response.status} - ${error.response.statusText} `;
              } else {
                this.alert.error = `${error.response.status} - ${error.response.statusText} `;
              }
            }
          } else {
            this.alert.error = error.message;
          }
          this.$refs.fadeAlertDanger.show();
        });
    },
  },
};
</script>